import React, { forwardRef, RefObject } from 'react';
import classNames from 'classnames';

import { StyledMenuButtonContentHeader } from './styles';
import { MenuButtonContentHeaderProps } from './types';
import { Comp, getContainerStylingTransientProps } from '@redsift/design-system';

const COMPONENT_NAME = 'MenuButtonContentHeader';
const CLASSNAME = 'redsift-combobox-content-header';

/**
 * The MenuButtonContentHeader component.
 */
export const MenuButtonContentHeader: Comp<MenuButtonContentHeaderProps, HTMLDivElement> = forwardRef((props, ref) => {
  const { transientProps, otherProps } = getContainerStylingTransientProps(props);

  const { children, className, ...forwardedProps } = otherProps;

  return (
    <StyledMenuButtonContentHeader
      {...forwardedProps}
      {...transientProps}
      className={classNames(MenuButtonContentHeader.className, className)}
      ref={ref as RefObject<HTMLDivElement>}
    >
      {children}
    </StyledMenuButtonContentHeader>
  );
});
MenuButtonContentHeader.className = CLASSNAME;
MenuButtonContentHeader.displayName = COMPONENT_NAME;
